require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-mobile-privacy-policy.json") })
        }
      }, "path---es-mobile-privacy-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-mobile-privacy-policy!./.cache/json/es-mobile-privacy-policy.json
// module id = 2522
// module chunks = 231608221292675